import React, { Children } from 'react'
import slugify from 'slugify'

const slugifyOptions = {
  lower: true,
  remove: /[^a-zA-Z0-9\s]/g,
}

const LinkedHeading = ({ children, tag: Tag }) => {
	const textContent = getTextContent(children)

	return (
		<Tag id={slugify(textContent, slugifyOptions)} className={Tag}>
			{children}
		</Tag>
	)
}

export default LinkedHeading

function getTextContent(children) {
	const textStrArr = Children.map(children, child => {
		if (typeof child === 'string') {
			return child
		} else if (child.props.children) {
			return getTextContent(child.props.children)
		}
	})

	return textStrArr.join('')
}
